export default {
    lang: 'en',
    title: 'Veterans Up | dentsu Ukraine',
    descriptions: "A career program for military personnel, veterans, and their families in the advertising industry from the largest communication group in Ukraine. It includes a training course in a number of specialties, mentoring, and career guidance.",
    keywords: 'education for veterans, career guidance, career, advertising industry, PPC training, SEO training, education for the military',
}